import React, { useEffect, useRef, useState } from 'react';
import PopupGeneric from '../../popup/popupGeneric';
import classNames from 'classnames';
import Button from '../../button/button';
import { useTranslation } from 'react-i18next';

/**
 * Hook para utilizar las modales
 * @returns 
 */
export const useModal = ({isOpen:_isOpen}={}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(_isOpen);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    return { isOpen, openModal, closeModal,t, bind: { isOpen, openModal, closeModal } };
}

/**
 * Hook para utilizar las modales de comfirmacion
 * @returns 
 */
export const useModalConfirm = () => {
    const {isOpen, openModal, closeModal} = useModal();
    return { isOpen, openModal, closeModal, bind: { isOpen, openModal, onClickClose:closeModal } };
 };

 /**
  * Este son los botones que podriamos usar en la modal para eliminar un registro
  * @param {*} param0 
  * @returns 
  */
export const ButtonsControlsDelete = ({ onClickClose, onClickAccept, labelacceptkey, labelclosekey }) => {
    const { t } = useTranslation();
    return (
        <div className='h-fit w-full flex justify-center gap-[24px]'>
            <Button typeB="button" variant={"primary-outline"} onClick={onClickClose} label={t(labelclosekey)} />
            <Button typeB="button" variant={"red-button"} onClick={onClickAccept} label={t(labelacceptkey)} />
        </div>
    )
}

/**
 * Posible header para informar al usuario que esta a punto de eliminar un registro
 * @param {*} param0 
 * @returns 
 */
export const Header1 = ({ typekey, keymessage }) => {
    const { t } = useTranslation();
    return (
        <div className='grid justify-center text-white text-[18px]'>
            <div className='text-center mb-4'>
                <strong>
                    {t("are_you_sure")} <label className='text-Red-500'>{t("remove").toLowerCase()}</label> {t(typekey)}?
                </strong>
            </div>
            <div className='text-center'>
                {t(keymessage)}
            </div>
        </div>
    )
};

/**
 * Modal de confirmacion que interactua  con otros opciones
 * @param {*} param0 
 * @returns 
 */
export const ModalConfirmDelete = ({ isOpen, ButtonsControls,Header, onClickClose, onClickAccept, customClass }) => {
    return (
        <PopupGeneric isOpen={isOpen}>
            <div className={classNames('bg-DarkBlue-600 round-[8px] bg-DarkBlue-600 rounded-[8px] border-2 border-[#6F7792] p-[24px_16px] gap-[4px] rounded-tl-[8px] border-t-2 w-[450px] h-fit', customClass)}>
                <div className='mb-8'>
                    <Header />
                </div>
                <div>
                    <ButtonsControls onClickClose={onClickClose} onClickAccept={onClickAccept} />
                </div>
            </div>
        </PopupGeneric>
    );
};

/**
 * Modal de confirmacion que interactua  con otros opciones
 * @param {*} param0 
 * @returns 
 */
export const Modal = ({ isOpen, children, customClass,className }) => {
    return (
        <PopupGeneric isOpen={isOpen}>
            <div className={classNames('round-[8px] bg-DarkBlue-600 rounded-[8px] border-2 border-[#6F7792] p-[24px_16px] gap-[4px] rounded-tl-[8px] border-t-2 w-[600px] h-fit', customClass,className)}>
                {children}
            </div>
        </PopupGeneric>
    );
};


export const DropdownOption = ({isOpen,openModal,closeModal,ButtonControl,className,children}) => {
    const dropdownRef = useRef(null); 
    const toggleMenu = () => {
        if(isOpen){
            closeModal();
        } else {
            openModal();
        }
    };
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            closeModal();
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
      // eslint-disable-next-line
    }, []);

  
    return (
      <div className="relative inline-block text-left">
        <ButtonControl onClick={toggleMenu}/>
        {isOpen && (
          <div
            ref={dropdownRef} // Asigna el ref al contenedor del menú
            className={classNames("absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",className)}
          >
            <div className="py-1">
              {children}
            </div>
          </div>
        )}
      </div>
    );
  };


